import React, { useState } from 'react';

import { Button } from 'antd';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { ListNoData } from 'presentation/components/ListNoData';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { CardData, tabProps } from '../models/CardModel';
import { CardComponent } from './Card';

const TAB1Children = ({
    propertyUseCase,
    type,
    tabId,
    setMember,
    isLoading,
    setNotice,
}: tabProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [listProperty, setListProperty] = useState<CardData[]>([]);
    const [page, setPage] = useState<number>(1);
    const [numPages, setNumPages] = useState<number>(1);
    const userSlice = useAppSelector((state) => state.user);

    React.useEffect(() => {
        // typeが0の場合は初期化が完了していないため、APIリクエストを送信しない
        if (userSlice?.isSignedIn && isLoading && type !== 0) {
            getListProperty({ tabId: tabId, type: type });
        }
    }, [type, isLoading]);

    const getListProperty = async (params: any) => {
        try {
            dispatch(startFetching());
            setListProperty([]);
            const response: any = await propertyUseCase.getListPropertisDashboard(params);
            if (response && response.status == 200) {
                const properties = response.result.properties;
                setMember(response.result.member);
                setListProperty(properties);
                setNotice(
                    properties.find(
                        (item: CardData) =>
                            item.currentTodo &&
                            item.currentTodo.todoExecStatus == 'DOING' &&
                            item.currentTodo.todoName,
                    ),
                );
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const handleScroll = async (e: any) => {
        if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
            if (numPages > page) {
                setPage((prev) => prev + 1);
            }
        }
    };
    const button = (
        <Button
            type="primary"
            size="large"
            style={{ width: 240, height: 40 }}
            onClick={() => {
                type == BUYER_CLASSIFICATION
                    ? navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_01}`)
                    : navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_01}`);
            }}
        >
            {type == BUYER_CLASSIFICATION ? '売り物件一覧' : '査定してみる'}
        </Button>
    );
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
            }}
            className="tab1-container mt-[30px] pr-[25px]"
        >
            {listProperty.length > 0 ? (
                <section
                    style={{
                        height: '100%',
                        backgroundColor: '#ffffff',
                        overflow: 'auto',
                        flexGrow: 1,
                    }}
                    className="wrapper-card py-[40px]"
                    onScroll={(e) => handleScroll(e)}
                >
                    <div style={{ width: 'fit-content' }}>
                        {type == BUYER_CLASSIFICATION && (
                            <div className="text-[20px] font-[700] text-left mb-[40px] text-[#000000]">
                                選定中
                            </div>
                        )}
                        <div className="grid-container">
                            {listProperty.map((element: CardData, index: number) => (
                                <CardComponent key={index} data={element} type={type} />
                            ))}
                        </div>
                    </div>
                </section>
            ) : (
                <ListNoData
                    title={
                        type == BUYER_CLASSIFICATION
                            ? '選定している物件がありません。'
                            : '査定物件はありません。'
                    }
                    button={button}
                />
            )}
        </div>
    );
};

export default TAB1Children;
